// src/services/apiClient.ts
import { Liferay } from './liferay';

let oAuth2Client: any;
let oAuth2ClientOTP: any;
let bidSpringOAuth2Client: any = null;

try {
    oAuth2ClientOTP = Liferay.OAuth2Client.FromUserAgentApplication(
        'dcip-spring-boot-oauth-application-user-agent'
    );
} catch (error) {
    console.error(error);
}


try {
    oAuth2Client = Liferay.OAuth2Client.FromUserAgentApplication(
        'bid-spring-boot-oauth-application-user-agent'
    );
} catch (error) {
    console.error(error);
}

const defaultHeaders = {
    'x-csrf-token': Liferay.authToken,
    jsessionid: Liferay.ThemeDisplay.getSessionId()
};
const scopeGroupId = Liferay?.ThemeDisplay.getScopeGroupId();
const isImpersonated = Liferay.ThemeDisplay.isImpersonated();
const doAsUserIdEncoded = Liferay.ThemeDisplay.getDoAsUserIdEncoded();
const authTocken = (window as any)?.Liferay?.authToken;

const appendDoAsUserId = (url: string) => {
    if (isImpersonated) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}doAsUserId=${encodeURIComponent(
            doAsUserIdEncoded
        )}&p_auth=${authTocken}`;
    } else {
        return `${url}?p_auth=${authTocken}`;
    }
};

const appendDoAsUserIdOTP = (url: string) => {
    return `${url}`;
};
export const apiClient = {
    post: async <T>(url: string, body: any): Promise<T> => {
        const updatedUrl = appendDoAsUserId(url);
        const response = await oAuth2Client.fetch(updatedUrl, {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            credentials: 'include'
        });
        // Assume response is already the parsed JSON object.
        const json = response;

        // Log the raw response from oAuth2Client.fetch to debug

        // Check for your custom statusCode for success
        if (!json.success) {
            throw new Error(json.message || 'An unknown error occurred');
        }
        return json;
    }
};


export const apiOTPClient = {
    post: async <T>(url: string, body: any): Promise<T> => {
        const updatedUrl = appendDoAsUserIdOTP(url);
        const response = await oAuth2ClientOTP.fetch(updatedUrl, {
            method: 'POST',
            headers: {
                ...defaultHeaders,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            credentials: 'include'
        });
        const json = response;
        // if (json.statusCode !== 200) throw new Error(json.message);
        return json;
    }
};
export const createUser = async (userData: any) => {
    const url = `/users/BID User/Business in Dubai?p_auth=${authTocken}&sendEmail=true&templateKey=bid-requestor-reset-password-notification&resetPasswordPathConfigKey=matchmaking-reset-password-path`;
    const response = await oAuth2ClientOTP.fetch(url, {
        method: 'POST',
        headers: {
            ...defaultHeaders,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    });
    
    return response;
};

interface WorkflowPayload {
    classPK: number;
    transition: string;
  }
  
  interface WorkflowResponse {
    statusCode: number;
    success: boolean;
    data?: any;
    message?: string;
  }
  
  export const submitWorkflowTask = async (payload: WorkflowPayload, url:string) => {
    const updatedUrl = appendDoAsUserId(url);
    const response = await oAuth2Client.fetch(updatedUrl, {
        method: 'POST',
        headers: {
            ...defaultHeaders,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'include'
    });
    return response;
};


export const getBidSpringOAuthClient = async () => {
    if (bidSpringOAuth2Client) return bidSpringOAuth2Client;

    if (!Liferay?.OAuth2Client) {
        throw new Error("Liferay bidSpringOAuth2Client not available");
    }

    bidSpringOAuth2Client =
        await Liferay.OAuth2Client.FromUserAgentApplication(
            'bid-spring-boot-oauth-application-user-agent'
        );

    return bidSpringOAuth2Client;
};